const CustomerNotification = {
  isLoadingMore: false,

  init: function () {
    this.handleMarkAsRead();
    this.handleMarkAllAsRead();
    this.handleLoadMore();
    this.handleInfiniteScroll();
  },

  handleMarkAsRead: function () {
    $(document).on("click", "#customer-notification .mark-as-read-btn", function (e) {
      e.preventDefault();

      const $btn = $(this);
      if ($btn.hasClass("button-loading")) {
        return;
      }

      const url = $btn.data("url");

      $.ajax({
        url: url,
        method: "POST",
        headers: {
          "X-CSRF-TOKEN": $("#customer-notification").data("csrf"),
        },
        beforeSend: function () {
          $btn.addClass("button-loading");
        },
        success: function () {
          const $item = $btn.closest(".customer-notification__item");
          $item.find(".is-read").remove();
          $btn.remove();
        },
        complete: function () {
          $btn.removeClass("button-loading");
        },
      });
    });
  },

  handleMarkAllAsRead: function () {
    $(document).on("click", "#customer-notification .mark-all-as-read-btn", function () {
      const $wrapper = $("#customer-notification");
      const $btn = $(this);
      if ($btn.hasClass("button-loading")) {
        return;
      }

      const url = $wrapper.data("read-all-url");

      $.ajax({
        url: url,
        method: "POST",
        headers: {
          "X-CSRF-TOKEN": $wrapper.data("csrf"),
        },
        beforeSend: function () {
          $btn.addClass("button-loading");
        },
        success: function () {
          $wrapper.find(".is-read").remove();
          $wrapper.find(".mark-as-read-btn").remove();
          $wrapper.find(".mark-all-as-read-btn").remove();
        },
        complete: function () {
          $btn.removeClass("button-loading");
        },
      });
    });
  },

  handleLoadMore: function () {
    $(document).on("click", "#customer-notification .customer-notification__load-more-btn", function () {
      CustomerNotification.loadMoreNotifications($("#customer-notification"), $(this));
    });
  },

  handleInfiniteScroll: function () {
    const self = this;

    $(window).on("scroll", function () {
      const $wrapper = $("#customer-notification");
      if (!$wrapper.length) {
        return;
      }

      const hasMore = String($wrapper.data("has-more")) === "true";
      if (!hasMore || self.isLoadingMore) {
        return;
      }

      const viewportBottom = $(window).scrollTop() + $(window).height();
      const $loadMore = $wrapper.find(".customer-notification__load-more");
      const offsetData = $loadMore.offset();
      const loadMoreTop = offsetData ? offsetData.top : undefined;

      if (typeof loadMoreTop === "undefined") {
        return;
      }

      if (viewportBottom + 120 >= loadMoreTop) {
        self.loadMoreNotifications($wrapper, $wrapper.find(".customer-notification__load-more-btn"));
      }
    });

    $(window).trigger("scroll");
  },

  loadMoreNotifications: function ($wrapper, $btn) {
    const hasMore = String($wrapper.data("has-more")) === "true";
    if (!hasMore || this.isLoadingMore) {
      return;
    }

    const url = $wrapper.data("load-more-url");
    const offset = $wrapper.data("next-offset");
    const self = this;

    $.ajax({
      url: url,
      method: "GET",
      data: { offset: offset },
      beforeSend: function () {
        self.isLoadingMore = true;
        $btn.addClass("button-loading").prop("disabled", true);
      },
      success: function (response) {
        $wrapper.find(".customer-notification__list").append(response.html);
        $wrapper.data("next-offset", response.next_offset);
        $wrapper.data("has-more", response.has_more ? "true" : "false");

        if (!response.has_more) {
          $btn.closest(".customer-notification__load-more").remove();
        }
      },
      complete: function () {
        self.isLoadingMore = false;
        $btn.removeClass("button-loading").prop("disabled", false);
      },
    });
  },
};

$(document).ready(function () {
  if ($("#customer-notification").length) {
    CustomerNotification.init();
  }
});
